import React from 'react';
import Footer from './Footer';
import Upcoming from './Upcoming';
import Balance from './Balance';

export default function Layout() {
  return (
    <div className="p-16 w-100 h-100">
      <div className="leave">
        <div className="leave-content">
          <div className="mb-16"><Balance /></div>
          <Upcoming />
        </div>
        <div className="leave-footer">
          <Footer />
        </div>
      </div>
    </div>
  );
}
